export default "__VITE_ASSET__oj5CvbHZ__"